// SPDX-License-Identifier: AGPL-3.0-or-later

import {SubMenu} from '@app/features/ui/action_menu/ContextMenu';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface MenuItemSubmenuProps {
	label: string;
	disabled?: boolean;
	hint?: string;
	danger?: boolean;
	render: () => React.ReactNode;
	onTriggerSelect?: () => void;
}
export const MenuItemSubmenu: React.FC<MenuItemSubmenuProps> = observer(
	({label, disabled = false, hint, danger = false, render, onTriggerSelect}) => {
		return (
			<SubMenu label={label} disabled={disabled} hint={hint} danger={danger} onTriggerSelect={onTriggerSelect}>
				{render()}
			</SubMenu>
		);
	},
);
